import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export * from 'gsap'
export * from 'gsap/Draggable'
export * from 'gsap/MotionPathPlugin'
export * from 'gsap/ScrollTrigger'

gsap.registerPlugin(Draggable, MotionPathPlugin, ScrollTrigger)
